import { render, staticRenderFns } from "./Scientist.vue?vue&type=template&id=24606150&scoped=true&"
import script from "./Scientist.vue?vue&type=script&lang=js&"
export * from "./Scientist.vue?vue&type=script&lang=js&"
import style0 from "./Scientist.vue?vue&type=style&index=0&id=24606150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24606150",
  null
  
)

export default component.exports